const style = document.createElement('style');
style.innerHTML = `

#supafeedback-modal{
    font-family: Arial, sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 9999;
}

.supafeedback-content {
    margin: 100px auto;
    padding: 20px;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    width: 70%;
    max-width: 500px;
    position: relative;
}

.supafeedback-close {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
}

.supafeedback-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.supafeedback-form input, .supafeedback-form textarea {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid purple;
    resize: none;
}

.supafeedback-title {
    font-size: 24px;
    margin: 0;
    margin-bottom: 8px;
}

.supafeedback-btn-main {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
}

.supafeedback-btn {
    font-family: Arial, sans-serif;
    padding: 4px;
    background-color: transparent;
    color: purple;
    cursor: pointer;
    border-radius: 5px;
    border: 2px solid #9370DB;
}

.supafeedback-btn-active, .supafeedback-btn:focus, .supafeedback-btn:hover {
    border: 2px solid purple;
    color: white;
    background-color: purple;  
    transition: 0.5s;  
}

.supafeedback-btn:hover {
      border: 2px solid purple;
}

`;
document.head.appendChild(style);
